export default "__VITE_ASSET__0b81f343__"